import { useEffect, useState } from "react";
import  AgoraManager  from "./agoraManager";
import  AgoraAudioManager  from "./AgoraAudioManager";
import config from "./config";
import { useClientEvent, useRTCClient } from "agora-rtc-react";

// async function fetchRTCToken(channelName: string) {
//   if (config.serverUrl !== "") {
//     try {
//       const response = await fetch(
//         `${config.proxyUrl}${config.serverUrl}/rtc/${channelName}/publisher/uid/${config.uid}/?expiry=${config.tokenExpiryTime}`
//       );
//       const data = await response.json() as { rtcToken: string };
//       console.log("RTC token fetched from server: ", data.rtcToken);
//       return data.rtcToken;
//     } catch (error) {
//       console.error(error);
//       throw error;
//     }
//   } else {
//     return config.rtcToken;
//   }
// }

const useTokenWillExpire = () => {
  const agoraEngine = useRTCClient();
  // useClientEvent(agoraEngine, "token-privilege-will-expire", () => {
  //   if (config.serverUrl !== "") {
  //     fetchRTCToken(config.channelName)
  //       .then((token) => {
  //         console.log("RTC token fetched from server: ", token);
  //         if (token) return agoraEngine.renewToken(token);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   } else {
  //     console.log("Please make sure you specified the token server URL in the configuration file");
  //   }
  // });
};

function AuthenticationWorkflowManager({client, ...props}) {
  const [channelName, setChannelName] = useState("");
  const [joined, setJoined] = useState(false);
  useTokenWillExpire();

  console.log(props)

  const fetchTokenFunction = async () => {
    
      try {
        const token = props.token;
        config.rtcToken = token;
        config.channelName = props.channel;
        config.uid = props.uid;
        config.appId = props.appId;
        setJoined(true);
      } catch (error) {
        console.error(error);
      }
  
  };


  useEffect(() => {
    fetchTokenFunction();
  }, [channelName, props.token]);

  return (
    <div>
      {joined && (
       !props?.isAudio ? <>
          {/* <button onClick={() => setJoined(false)}>Leave</button> */}
          <AgoraManager client = {client} setJoined={setJoined} mode={props.mode} config={config}>
            {props.children}
          </AgoraManager>
        </>
        : 
        <>
          {/* <button onClick={() => setJoined(false)}>Leave</button> */}
          <AgoraAudioManager client = {client} setJoined={setJoined} mode={props.mode} config={config}>
            {props.children}
          </AgoraAudioManager>
        </>
      )}
    </div>
  );
}

export default AuthenticationWorkflowManager;
